/* ═══════════════════════════════════════
   NOOON - Autoplay video kick-start
   iOS Safari and some Android browsers ignore the autoplay
   attribute unless .play() is called programmatically.
   ═══════════════════════════════════════ */
(function () {
  function kickVideos() {
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      if (v.paused) {
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () { /* autoplay blocked - stays paused silently */ });
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kickVideos);
  } else {
    kickVideos();
  }
  /* Re-attempt after a short delay for slow-loading videos */
  setTimeout(kickVideos, 800);
})();

/* ═══════════════════════════════════════
   NOOON - Sticky CHAT button
   Fixed on screen during first 3 sections,
   stops at campaign bottom, resumes on scroll up.
   ═══════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {
  var chatBtn = document.querySelector('[data-chat-sticky]');
  if (!chatBtn) return;

  var campaign = document.querySelector('.campaign');
  if (!campaign) return;

  var lightSections = document.querySelectorAll('.lookbook, .lookbook-section');
  var bottomGap = 40;
  var campaignEnd = 0;

  function measure() {
    campaignEnd = campaign.offsetTop + campaign.offsetHeight;
  }

  function update() {
    var btnHeight = chatBtn.offsetHeight;
    var pinY = campaignEnd - btnHeight - bottomGap;
    var scrollY = window.scrollY || window.pageYOffset;
    var viewportBottom = scrollY + window.innerHeight - bottomGap;

    if (viewportBottom > campaignEnd) {
      /* Past campaign - pin absolutely at campaign bottom */
      chatBtn.style.position = 'absolute';
      chatBtn.style.top = pinY + 'px';
      chatBtn.style.bottom = 'auto';
    } else {
      /* Within first 3 sections - fixed to viewport */
      chatBtn.style.position = 'fixed';
      chatBtn.style.top = 'auto';
      chatBtn.style.bottom = bottomGap + 'px';
    }

    /* Color: dark text over light sections */
    var btnMid = chatBtn.getBoundingClientRect().top + btnHeight / 2;
    var onLight = false;
    lightSections.forEach(function (sec) {
      var r = sec.getBoundingClientRect();
      if (r.top < btnMid && r.bottom > btnMid) onLight = true;
    });
    chatBtn.classList.toggle('chat-sticky--dark', onLight);
  }

  measure();
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', function () { measure(); update(); }, { passive: true });
});
